import { CLEAR_BUTTON_ON_HOVER_CLASS } from '~/chords/lib/clearButtonOnHover';
import { cn } from '~/chords/lib/cn';
import { variants } from '~/chords/lib/variants';

export const chevron = variants({
  base: cn('transform duration-300'),
  variants: {
    state: {
      default: cn('rotate-0'),
      open: cn('rotate-180'),
    },
  },
});

export const DROPDOWN_TRIGGER_CLEAR_BUTTON_CLASS = cn(
  'absolute right-[2.25rem] top-1/2 -translate-y-1/2',
  'size-xl items-center justify-center rounded-full p-xs',
  'text-default hover:bg-emphasis-strong',
  CLEAR_BUTTON_ON_HOVER_CLASS,
);

export const DROPDOWN_OPTION_CLEAR_CLASS = cn(
  'flex min-h-[36px] w-full cursor-pointer items-center gap-sm px-md text-body-sm text-default',
  'transition-colors duration-300 hover:bg-emphasis-strong focus:outline-none focus:bg-emphasis-strong',
);
